export default __webpack_public_path__ + "images/d95678a92bb33f50318bf5906220e2b5.svg";